/**
 * Converts a Blob to a base64-encoded string using FileReader.readAsDataURL.
 *
 * This is a client-side utility — do NOT import in server-only modules.
 * It avoids the char-by-char Uint8Array → btoa concatenation pattern that
 * blocks the main thread for several seconds on large captures.
 *
 * @param blob - The Blob (e.g. a PNG capture from getDisplayMedia) to encode.
 * @returns The raw base64 string without the `data:<mime>;base64,` prefix.
 */
export function blobToBase64(blob: Blob): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => {
      const result = reader.result as string
      resolve(result.split(',')[1] ?? '')
    }
    reader.onerror = () => {
      reject(reader.error ?? new Error('FileReader failed to read blob'))
    }
    reader.readAsDataURL(blob)
  })
}
